import { render, staticRenderFns } from "./PrecoloredSVGGroup.vue?vue&type=template&id=d9e4708c&"
import script from "./PrecoloredSVGGroup.vue?vue&type=script&lang=js&"
export * from "./PrecoloredSVGGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports